module.exports = __webpack_public_path__ + "img/tulip.bc59d66d.svg";